import env from '#shared/config/env.js';
import taxList from '#shared/config/taxList/taxList-unformatted.json' with { type: 'json' };

/**
 * Transform country object to a correct format for a country selector
 * @param {object[]} countries
 * @param {string} [countries[].value] - Country code (GEN)
 * @param {string} [countries[].label] - Label (GEN)
 * @param {object} countriesLocalization
 * @returns {object[]}
 */
export default (countries, countriesLocalization) => {
	// List of all countries which have svg flag available
	return countries.map((countryObject) => {
		const countryCode = countryObject.value;
		const displayName = countryObject.label;
		const taxCountry = taxList.find((country) => country.code === countryCode);
		return {
			value: countryCode,
			label: countriesLocalization && countriesLocalization[countryCode] ? countriesLocalization[countryCode] : displayName,
			hasIcon: env.countriesWithFlag.includes(countryCode),
			taxPlaceholder: taxCountry ? taxCountry.placeholder : ''
		};
	});
};
